export const aboutInfo = {
  brandName: '911爆料网',
  tagline: '网红黑料 · 明星塌房 · 每日吃瓜',
  description: '911爆料网成立于2020年，是国内领先的娱乐资讯与爆料追踪平台。我们专注于网红黑料、明星塌房事件、每日吃瓜资讯的实时追踪与深度报道，致力于为广大网友提供最真实、最及时、最深度的娱乐爆料内容。',
  mission: '做最有态度的娱乐爆料平台，让每一个吃瓜群众都能第一时间掌握真相。',
  stats: [
    { label: '累计爆料', value: '12,860+' },
    { label: '日活用户', value: '850万+' },
    { label: '追踪事件', value: '3,200+' },
    { label: '合作媒体', value: '200+' },
  ],
  testimonials: [
    { name: '小王', role: '忠实用户', content: '每天必刷911爆料网，信息更新快，内容真实可靠，吃瓜首选！' },
    { name: '娱乐评论人李老师', role: '行业专家', content: '911爆料网的深度追踪报道在业内口碑很好，很多独家内容确实领先同行。' },
    { name: '匿名用户', role: '铁粉', content: '从2020年就开始关注了，从来没让我失望过。每次有大瓜都是911先爆出来的。' },
  ],
  contact: {
    email: 'tips@911baoliao.com',
    wechat: '911baoliaowang',
    weibo: '@911爆料网官方',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
  },
};